import { USER_STATUS, USER_LEVEL } from '../../../utils/constants/commonValues';
import moment from 'moment';

function User(data) {
    this.tableData = this.createTableData(data);
    this.pagination = this.createPaginationData(data);
}

User.prototype = Object.assign(User.prototype, {
    createTableData(tableData) {
        return (
            tableData &&
            tableData.userDetailsList &&
            tableData.userDetailsList.map(row => this.createRow(row))
        );
    },
    createPaginationData(data) {
        if (data) {
            const { currentPage, totalRecord } = data;
            return {
                hasNextPage: false,
                hasPreviousPage: false,
                pageNumber: currentPage,
                pageSize: 10,
                sortingCriteria: '',
                totalNumberOfPages: 0,
                totalNumberOfRecords: totalRecord,
            };
        }
        return {};
    },
    createRow(row) {
        const {
            lastUpdatedBy,
            lastUpdatedDate,
            lastUpdatedByName,
            userCreatedBy,
            userCreatedByName,
            userCreatedDate,
            userDetails,
            userLevel,
            userRole,
            userRoleId,
            entityId,
            entityName,
            comment,
            level,
            parentUserId,
        } = row;
        const {
            userStatus,
            email,
            errorMessage,
            name,
            statusCode,
            userId,
        } = userDetails;
        return {
            lastUpdatedBy,
            lastUpdatedByName,
            entityId,
            lastUpdatedDate: this.convertDate(lastUpdatedDate),
            entityName,
            userCreatedBy,
            userCreatedByName,
            userCreatedDate: this.convertDate(userCreatedDate),
            userRole: this.getUserRole(userRoleId),
            userRoleName: this.getUserRole(userRole),
            userLevel: this.getUserLevel(userLevel),
            level: level,
            uLevel: level,
            supervisor: parentUserId,
            userStatus: this.getStatus(userStatus),
            email,
            errorMessage,
            name,
            statusCode,
            userId,
            comment,
        };
    },
    convertDate(date) {
        const dateString = moment(date).format('DD/MM/YYYY');
        return dateString;
    },
    getStatus(status) {
        return USER_STATUS[status];
    },
    getUserRole(role) {
        return role || '-';
    },
    getUserLevel(level) {
        // if (level === 'ADMIN') {
        //     return 'Admin';
        // }
        return USER_LEVEL[level];
    },
});

export default User;
